import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/components/template/header/header.service';

@Component({
  selector: 'eM-product-crud',
  templateUrl: './product-crud.component.html',
  styleUrls: ['./product-crud.component.css']
})
export class ProductCrudComponent implements OnInit {

  constructor(private router: Router, private headerService: HeaderService) {
    this.headerService.headerData = {
      title: 'Gestao de Produto -> Produto',
      icon: 'local_mall',
      routeUrl: '/products'
    }
  }

  ngOnInit(): void {
  }


  navigateProductCreate(): void {
    this.router.navigate(['/products/create'])
  }

}
